import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white py-5">
      <div className="container">
        <div className="row g-4">
          {/* Columna 1 - Branding */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="d-flex align-items-center mb-3">
              <img 
                src={`${process.env.PUBLIC_URL || ''}/images/logofooter.png`}
                alt="No Multas - Tránsito & Derecho" 
                style={{ height: '50px', width: 'auto' }}
              />
            </div>
            <p className="text-light small mb-3">
              Servicio especializado en gestión y resolución de fotomultas.
            </p>
          </div>

          {/* Columna 2 - Enlaces Rápidos */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="mb-3">Enlaces Rápidos</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#inicio" className="text-light text-decoration-none hover-white">Inicio</a>
              </li>
              <li className="mb-2">
                <a href="#como-funciona" className="text-light text-decoration-none hover-white">Consultar Multas</a>
              </li>
              <li className="mb-2">
                <a href="#nosotros" className="text-light text-decoration-none hover-white">Servicios</a>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Contacto */}
          <div className="col-12 col-lg-6">
            <h5 className="mb-3">Contacto</h5>
            <ul className="list-unstyled">
              <li className="mb-3">
                <a
                  href="mailto:drocco@transitoyderecho.com.ar"
                  className="text-light text-decoration-none hover-white d-flex align-items-center"
                >
                  <i className="bi bi-envelope text-primary me-2"></i>
                  <span>drocco@transitoyderecho.com.ar</span>
                </a>
              </li>
              <li className="mb-3">
                <a
                  href="tel:+5491123625754"
                  className="text-light text-decoration-none hover-white d-flex align-items-center"
                >
                  <i className="bi bi-telephone text-primary me-2" aria-hidden="true"></i>
                  <span>11 2362-5754</span>
                </a>
              </li>
              <li className="mb-3">
                <div className="d-flex align-items-center text-light small">
                  <i className="bi bi-geo-alt text-primary me-2 flex-shrink-0" aria-hidden="true"></i>
                  <address className="mb-0" style={{ fontStyle: 'normal' }}>
                    Saldías 273, Morón, Buenos Aires
                  </address>
                </div>
              </li>
              <li className="mb-0">
                <div className="rounded-2 overflow-hidden border border-secondary mt-2" style={{ maxWidth: '100%' }}>
                  <iframe
                    title="Ubicación — Dr. Adolfo Saldías 273, Morón"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6564.684524299315!2d-58.6257388!3d-34.6460583!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb8a05b54363f%3A0x6998c57e2fcf44c!2sDr.%20Adolfo%20Sald%C3%ADas%20273%2C%20B1708JLE%20Mor%C3%B3n%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1775074570923!5m2!1ses!2sar"
                    width="100%"
                    height="260"
                    style={{ border: 0, display: 'block' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Barra de Copyright */}
        <div className="border-top border-secondary mt-4 pt-4">
          <p className="text-center small mb-0" style={{ color: '#9ca3af' }}>
            © {currentYear} Transito & Dercho. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

